(function(){
  const suffixes = ['2RS','2Z','ZZ','RS','Z'];
  function normalizeToken(token){
    const compact=token.replace(/[^A-Z0-9]/g,'');
    if(!/\d/.test(compact)) return compact;
    for(const suffix of suffixes){
      if(compact===suffix) return compact;
      if(compact.length>suffix.length && compact.endsWith(suffix)) return compact.slice(0,-suffix.length)+' '+suffix;
    }
    return compact;
  }
  function normalizeQuery(value){
    return value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toUpperCase().trim().split(/[\s\-_/]+/).filter(Boolean).map(normalizeToken).join(' ').replace(/\s+/g,' ');
  }
  function init(){
    const form=document.querySelector('.sd-search[data-sd-technical-search]');
    if(!form) return;
    const input=form.querySelector('input[name="q"]');
    const results=form.querySelector('[data-sd-tech-results]');
    let timer,controller,lastTerm='';
    async function load(){
      const term=normalizeQuery(input.value);
      if(term.length<2){results.classList.remove('is-open');results.innerHTML='';return;}
      lastTerm=term;
      controller?.abort(); controller=new AbortController();
      results.innerHTML='<div class="sd-tech-search-loading">Ricerca in corso…</div>';results.classList.add('is-open');
      try{
        const base=window.routes?.predictive_search_url||'/search/suggest';
        const url=base+'?q='+encodeURIComponent(term)+'&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=show&section_id=predictive-search';
        const response=await fetch(url,{signal:controller.signal,headers:{Accept:'text/html'}});
        if(!response.ok) throw new Error('HTTP '+response.status);
        const html=await response.text();const doc=new DOMParser().parseFromString(html,'text/html');
        const panel=doc.querySelector('[data-sd-technical-predictive]');
        if(!panel) throw new Error('Risultati non disponibili');
        results.innerHTML=panel.innerHTML;results.dataset.term=term;results.dataset.familyUrl=panel.dataset.familyUrl||'';results.dataset.directUrl=panel.dataset.directUrl||'';results.dataset.hasBrand=panel.dataset.hasBrand||'false';window.SDBrandOrder.sortBrandElements(results);results.classList.add('is-open');
      }catch(error){if(error.name!=='AbortError')results.innerHTML='<div class="sd-tech-search-error">Impossibile caricare i suggerimenti.</div>';}
    }
    input.addEventListener('input',()=>{clearTimeout(timer);timer=setTimeout(load,180)});
    input.addEventListener('focus',()=>{if(results.innerHTML)results.classList.add('is-open')});
    document.addEventListener('click',event=>{if(!form.contains(event.target))results.classList.remove('is-open')});
    form.addEventListener('submit',()=>{
      input.value=normalizeQuery(input.value);
    });
    form.addEventListener('keydown',event=>{if(event.key==='Escape')results.classList.remove('is-open')});
  }
  window.SDTechnicalSearch={brandPriority:window.SDBrandOrder.priority,normalizeQuery,sortBrandElements:window.SDBrandOrder.sortBrandElements};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{window.SDBrandOrder.sortBrandElements();init()});else{window.SDBrandOrder.sortBrandElements();init()}
})();
